import { Icon } from '@eventbrite/eds-icon';
import classNames from 'classnames';
import React from 'react';

export interface IHeaderIconProps {
    iconType?: any;
    iconColor?: string;
    iconSize?: string;
    iconBottomSpacing?: string;
    shouldNotModifyIcon?: boolean;
}

const HeaderIcon = ({
    iconType,
    iconColor,
    iconSize,
    iconBottomSpacing = 'eds-l-mar-bot-6',
    shouldNotModifyIcon,
}: IHeaderIconProps) => {
    const classes = classNames(
        iconBottomSpacing,
        'eds-fx--pop eds-fx--delay-1',
        'auth-lib__header__icon',
        {
            'auth-lib__header__icon-default': shouldNotModifyIcon,
        },
    );

    const conditionalProps = shouldNotModifyIcon
        ? {}
        : { size: iconSize, color: iconColor };

    return (
        <div className={classes} data-testid="page-header-icon">
            <Icon type={iconType} {...conditionalProps} />
        </div>
    );
};

export default HeaderIcon;
